<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <main class="main-content position-relative border-radius-lg ">
      <!-- Navbar -->
      <HeaderMenu></HeaderMenu>
      <!-- End Navbar -->
      <div class="container-fluid pt-6" style="min-height: 100vh;">
        <div v-for="(notification, index) in notifications" :key="index" class="alert position-fixed top-0 end-0 m-3"
             :class="notification.class" role="alert" style="color: white; z-index: 9999; max-width: 360px;">
          {{ notification.message }}
          <button style="font-size: small" type="button" class="btn-close" @click="closeNotification(index)"
                  aria-label="Close"></button>
        </div>

        <div class="d-flex justify-content-around">

          <div class="card w-45">
            <div class="card-body px-0 pt-0 pb-2 row">
              <div class="col-1 h-25"> </div>
              <div class=" col-10 h-100">
                <div class="border rounded p-3 text-center h-100" @drop.prevent="handleDrop" @dragover.prevent @dragleave.prevent :class="{ 'bg-light': isDragging }">
                  <div class="h-100 d-flex flex-column justify-content-center" v-if="!archivo.value" style="min-height: 80vh">
                    <label class="labelFile" @click="triggerFileInput">
                        <span>
                          <svg xml:space="preserve" viewBox="0 0 184.69 184.69" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Capa_1" version="1.1" width="60px" height="60px"><g><g><g><path d="M149.968,50.186c-8.017-14.308-23.796-22.515-40.717-19.813 C102.609,16.43,88.713,7.576,73.087,7.576c-22.117,0-40.112,17.994-40.112,40.115c0,0.913,0.036,1.854,0.118,2.834 C14.004,54.875,0,72.11,0,91.959c0,23.456,19.082,42.535,42.538,42.535h33.623v-7.025H42.538 c-19.583,0-35.509-15.929-35.509-35.509c0-17.526,13.084-32.621,30.442-35.105c0.931-0.132,1.768-0.633,2.326-1.392 c0.555-0.755,0.795-1.704,0.644-2.63c-0.297-1.904-0.447-3.582-0.447-5.139c0-18.249,14.852-33.094,33.094-33.094 c13.703,0,25.789,8.26,30.803,21.04c0.63,1.621,2.351,2.534,4.058,2.14c15.425-3.568,29.919,3.883,36.604,17.168 c0.508,1.027,1.503,1.736,2.641,1.897c17.368,2.473,30.481,17.569,30.481,35.112c0,19.58-15.937,35.509-35.52,35.509H97.391 v7.025h44.761c23.459,0,42.538-19.079,42.538-42.535C184.69,71.545,169.884,53.901,149.968,50.186z" style="fill:#010002;"></path></g><g><path d="M108.586,90.201c1.406-1.403,1.406-3.672,0-5.075L88.541,65.078 c-0.701-0.698-1.614-1.045-2.534-1.045l-0.064,0.011c-0.018,0-0.036-0.011-0.054-0.011c-0.931,0-1.85,0.361-2.534,1.045 L63.31,85.127c-1.403,1.403-1.403,3.672,0,5.075c1.403,1.406,3.672,1.406,5.075,0L82.296,76.29v97.227 c0,1.99,1.603,3.597,3.593,3.597c1.979,0,3.59-1.607,3.59-3.597V76.165l14.033,14.036 C104.91,91.608,107.183,91.608,108.586,90.201z" style="fill:#010002;"></path></g></g></g></svg>
                        </span>
                      <p>Arrastra y suelta un archivo aquí o haz clic para subirlo!</p>
                    </label>
                    <input type="file" class="d-none" ref="fileInput" @change="handleFileInput"/>
                  </div>
                  <div v-if="archivo.value" style="min-height: 80vh">
                    <template v-if="archivo.value.tipo.startsWith('image/')">
                      <img :src="archivo.value.url" class="img-fluid rounded" alt="Previsualización de imagen" />
                    </template>
                    <template v-else-if="archivo.value.tipo === 'application/pdf'">
                      <embed :src="archivo.value.url" type="application/pdf" class="w-100" style="min-height: 70vh;" />
                    </template>
                    <button class="btn btn-danger mt-3" @click="eliminarArchivo">Eliminar Archivo</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card w-45">
            <div class="card-header pb-0 d-flex">
              <select class="form-select" v-model="selectEsquemas">
                <option v-for="(esquema, index) in esquemas" :key="esquema.id" :value="index">{{esquema.nombre}}</option>
              </select>
            </div>
              <div class="card-body px-0 pt-0 pb-2 row">
                <div class="col-1 h-25"> </div>
              <div class="col-10">
                <form @submit.prevent="crearRegistro" >
                  <div v-for="propiedad in esquemaSeleccionado.propiedades" :key="'nuevo_' + propiedad.id" class="form-group">
                    <label class="form-control-label">{{ propiedad.nombre }}</label>
                    <template v-if="propiedad.tipo === 'text'">
                      <input class="form-control" style="min-height: 45px" type="text" v-model="nuevoRegistro.value[propiedad.campoBD]">
                    </template>
                    <template v-else-if="propiedad.tipo === 'longtext'">
                      <textarea class="form-control" style="min-height: 100px" v-model="nuevoRegistro.value[propiedad.campoBD]"></textarea>
                    </template>
                    <template v-else-if="propiedad.tipo === 'integer'">
                      <input class="form-control" style="min-height: 45px" type="number" step="1" v-model.number="nuevoRegistro.value[propiedad.campoBD]">
                    </template>
                    <template v-else-if="propiedad.tipo === 'decimal'">
                      <input class="form-control" style="min-height: 45px" type="number"  :value="parseFloat(nuevoRegistro.value[propiedad.campoBD])"  @input="updateDecimalNuevo(propiedad.campoBD, $event, 2)">
                    </template>
                    <template v-else-if="propiedad.tipo === 'decimal2'">
                      <input class="form-control" style="min-height: 45px" type="number" step="0.01"  :value="formatDecimal(nuevoRegistro.value[propiedad.campoBD], 2)"  @input="updateDecimalNuevo(propiedad.campoBD, $event, 2)">
                    </template>
                    <template v-else-if="propiedad.tipo === 'decimal4'">
                      <input class="form-control" style="min-height: 45px" type="number" step="0.0001"  :value="formatDecimal(nuevoRegistro.value[propiedad.campoBD], 4)"  @input="updateDecimalNuevo(propiedad.campoBD, $event, 4)">
                    </template>
                    <template v-else-if="propiedad.tipo === 'date'">
                      <input class="form-control" style="min-height: 45px" type="date" v-model="nuevoRegistro.value[propiedad.campoBD]" >
                    </template>
                  </div>
                  <button type="submit" class="btn btn-success">Guardar</button>
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                </form>
              </div>
            </div>
          </div>



        </div>
      </div>
    </main>

  </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu.vue";
import {onMounted, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
import axiosInstance from "@/axios";
import "datatables.net";
import "datatables.net-bs5";

export default {
  name: "TableView",
  components: {HeaderMenu},
  setup() {
    const router = useRouter();
    const esquemas = ref([]);
    const esquemaSeleccionado = ref({});
    const notifications = ref([]);

    // Función para cerrar una notificación
    const closeNotification = (index) => {
      notifications.value.splice(index, 1);
    };

    const cargando = ref(false);

    // Función para obtener los datos del backend
    const fetchEsquemas = async () => {
      cargando.value = true; // Activar el spinner
      try {
        const response = await axiosInstance.get("/api/esquemas");
        esquemas.value = response.data.esquemas || [];

        nuevoRegistro.value = esquemas.value[0].propiedades.reduce((acc, propiedad) => {
          acc[propiedad.campoBD] = propiedad.tipo === "integer" || propiedad.tipo === "decimal" ? 0 : ""; // Inicializar según tipo
          return acc;
        }, {});

        esquemaSeleccionado.value = esquemas.value[0];
      } catch (error) {
        showNotification("Error al obtener los datos", 'alert-danger');
      } finally {
        cargando.value = false; // Desactivar el spinner
      }
    };

    onMounted(() => {
      if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        const messageChannel = new MessageChannel();

        messageChannel.port1.onmessage = (event) => {
          const { data } = event;
          if (data.type === 'shared-pdf') {
            const {name, type, buffer } = data.file;
            const blob = new Blob([buffer], { type });

            // Convertir el blob en un objeto File
            const file = new File([blob], name , { type });
            procesarArchivo(file);
          } else {
            console.log('No se recibió ningún archivo PDF');
          }
        };


        navigator.serviceWorker.controller.postMessage('get-shared-pdf', [messageChannel.port2]);
      }

      fetchEsquemas();
    });



    const showNotification = (message, type) => {
      const notification = {
        message,
        class: type,
      };
      notifications.value.push(notification);

      // Cerrar la notificación automáticamente después de 2 segundos
      setTimeout(() => {
        closeNotification(notifications.value.indexOf(notification));
      }, 2000); // 2000 milisegundos = 2 segundos
    };

    // Formatear decimales a un número con precisión fija
    const formatDecimal = (value, digits) => {
      return value ? parseFloat(value).toFixed(digits) : "";
    };
    const formatDate = (value) => {
      if(value){
        const d = new Date(value);
        return ("0" + d.getDate()).slice(-2) + "/" + ("0"+(d.getMonth()+1)).slice(-2) + "/" + d.getFullYear();
      }else{
        return '';
      }
    };


    // Actualizar decimales en el modelo
    const updateDecimalNuevo = (campo, event, digits) => {
      const value = parseFloat(event.target.value).toFixed(digits);
      nuevoRegistro[campo] = isNaN(value) ? null : parseFloat(value);
    };

    const nuevoRegistro = reactive({});

    // Función para crear un nuevo registro
    const crearRegistro = async () => {
      try {
        await axiosInstance.post("/api/registroesquema/"+ esquemaSeleccionado.value.id, {
        registro: nuevoRegistro.value,
        archivo: archivo.value});

        



        //Redirigir al esquema seleccionado
        router.push({ path: `/esquema/${esquemaSeleccionado.value.id}` })
      } catch (error) {
        const mensaje = error.data || 'Error al crear el registro';
        showNotification(mensaje, 'alert-danger');
      }
    };

    const archivo = reactive({});
    const isDragging = reactive(false);
    const fileInput = ref(null);
    const triggerFileInput = () => {
      // Dispara el clic en el input de archivo
      fileInput.value.click();
    };

    const handleDrop = (event) => {
      const file = event.dataTransfer.files[0];
      procesarArchivo(file);
    };
    const handleFileInput = (event) => {
      const file = event.target.files[0];
      procesarArchivo(file);
    };
    const procesarArchivo = (file) => {
      if (!file) return;

      const reader = new FileReader();

      reader.onload = () => {
        const base64 = reader.result.split(",")[1]; // Extraer solo el base64 sin el prefijo
        const url = URL.createObjectURL(file);

        archivo.value = {
          nombre: file.name,
          tipo: file.type,
          url: url,
          base64: base64,
        };
      };

      reader.onerror = () => {
        console.error("Error al leer el archivo.");
      };

      reader.readAsDataURL(file); // Convierte el archivo a Base64
    };

    const eliminarArchivo = () => {
      archivo.value = null;
    };


    const selectEsquemas = ref(0);

    watch(selectEsquemas, () => {

      nuevoRegistro.value = {};
      esquemaSeleccionado.value = esquemas.value[selectEsquemas.value];

      nuevoRegistro.value = esquemaSeleccionado.value.propiedades.reduce((acc, propiedad) => {
        acc[propiedad.campoBD] = propiedad.tipo === "integer" || propiedad.tipo === "decimal" ? 0 : ""; // Inicializar según tipo
        return acc;
      }, {});

    });


    return {
      esquemas,
      esquemaSeleccionado,
      notifications,
      closeNotification,
      formatDecimal,
      formatDate,
      nuevoRegistro,
      crearRegistro,
      updateDecimalNuevo,
      handleDrop,
      handleFileInput,
      procesarArchivo,
      eliminarArchivo,
      archivo,
      isDragging,
      fileInput,
      triggerFileInput,
      selectEsquemas,
    };
  },
}
</script>

<style scoped>
.pdf-container {
  height: 70vh;
  width: 100%;
  overflow: auto;
  border: 1px solid #ccc;
}
.pdf-container-completa {
  height: 100dvh;
  width: 100%;
  overflow: auto;
  border: 1px solid #ccc;
}

.image-container img {
  max-width: 100%;
  height: auto;
}

.file-container {
  margin-top: 16px;
}
</style>
